const hexRGB = (hex: any) => {
  let hexValues = hex

  if (hexValues.length > 8) {
    throw new Error('The hex vuale is too long.')
  } else if (hexValues.length === 7) {
    hexValues = hexValues.slice(1)
  }

  const hexs = hexValues.match(/.{1,2}/g)
  const RGB = [
    parseInt(hexs[0], 16),
    parseInt(hexs[1], 16),
    parseInt(hexs[2], 16),
  ]

  return RGB
}

export default hexRGB
